import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classes from './ActivityTableEmbed.scss';
import ActivityTable from '../ActivityTable/ActivityTable';
import { SplitButton } from '../SplitButton/SplitButton';

class ActivityTableEmbed extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      view: 'table',
      filter: '',
    };
  }

  changeRenderMethod = value => {
    this.setState({ view: value });
  };

  render() {
    const props = this.props;

    const buttons = [
      {
        value: 'table',
        title: 'Tabelle',
      },
      {
        value: 'detail',
        title: 'Detailansicht',
      },
      {
        value: 'calendar',
        title: 'Kalender',
      },
    ];

    let title = 'Eigene Aktivitäten';
    if (typeof props.asParticipant !== 'undefined' && props.asParticipant) {
      title = 'Aktivitäten als Teilnehmer';
    }

    if (this.props.title.length) {
      title = this.props.title;
    }

    const count = Object.keys(
      _.filter(props.activities, o => o.deleted_at === null),
    ).length;

    return (
      <div>
        <div
          className={`${classes.top} ${
            count === 0 ? classes.empty : classes.full
          }`}
        >
          <h2 className="gutter">
            {count} {title}
          </h2>

          <SplitButton
            buttons={buttons}
            selected={this.state.view}
            onSelect={value => {
              this.changeRenderMethod(value);
            }}
          />
          <input
            className={classes.search}
            type="search"
            placeholder="Suche…"
            onChange={e => {
              this.setState({
                filter: e.target.value,
              });
            }}
          />
        </div>

        <ActivityTable
          activities={this.props.activities}
          staffs={this.props.staffs}
          mode={this.state.view}
          filter={this.state.filter}
          compact={this.props.compact}
        />
      </div>
    );
  }
}
ActivityTableEmbed.propTypes = {
  activities: PropTypes.array.isRequired,
  staffs: PropTypes.array,
  compact: PropTypes.bool,
  title: PropTypes.string,
  asParticipant: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
};

ActivityTableEmbed.defaultProps = {
  title: '',
};

export default ActivityTableEmbed;



// WEBPACK FOOTER //
// ./src/components/ActivityTableEmbed/ActivityTableEmbed.js